export default [
  { value: 'Night', label: 'Night' },
  { value: 'Week', label: 'Week' },
  { value: 'Entire Stay', label: 'Entire Stay' },
];
